import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop'; 
import Home from './Components/Home/Home';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import About from './Components/About/About';
import AdelaideService from './Components/AdelaideService/AdelaideService';
import MelbourneService from './Components/MelbourneService/MelbourneService';
import ContactUs from './Components/ContactUs/ContactUs';
import HomeCleaning from './Components/Services/HomeCleaning';
import CommercialCleaning from './Components/Services/CommercialCleaning';
import GutterCleaning from './Components/Services/GutterCleaning';
import RoofCleaning from './Components/Services/RoofCleaning';
import WindowCleaning from './Components/Services/WindowCleaning';
import PressureCleaning from './Components/Services/PressureCleaning';
import SolarCleaning from './Components/Services/SolarCleaning';
import NDISCleaning from './Components/Services/NDISCleaning';
import CarpetSteamCleaning from './Components/Services/CarpetSteamCleaning';
import OvenCleaning from './Components/Services/OvenCleaning';
import Faq from './Components/Faq/Faq';
import Blog from './Components/Blog/Blog';
import BlogDetail from './Components/BlogDetails/BlogDetail';
import GetQuote from './Components/GetQuote/GetQuote';
import OnceOffHouseCleaning from './Components/SubServices/OnceOffHouseCleaning';
import RegularHouseCleaning from './Components/SubServices/RegularHouseCleaning';
import EndofLeaseCleaning from './Components/SubServices/EndofLeaseCleaning';
import DeepHouseCleaning from './Components/SubServices/DeepHouseCleaning';
import OfficeCleaning from './Components/SubServices/OfficeCleaning';
import AgedCareCleaning from './Components/SubServices/AgedCareCleaning';
import SchoolCleaning from './Components/SubServices/SchoolCleaning';
import MedicalCentreCleaning from './Components/SubServices/MedicalCentreCleaning';
import GutterFlushing from './Components/SubServices/GutterFlushing';
import GutterVacuum from './Components/SubServices/GutterVacuum';
import RoofPressureWashing from './Components/SubServices/RoofPressureWashing';
import RoofSoftWash from './Components/SubServices/RoofSoftWash';
import FaqPage from './Components/Services/FaqPage';
import GoogleAddressInput from './Components/GoogleAddressInput';
import OpenCageAutocomplete from './Components/OpenCageAutocomplete';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <BrowserRouter>
      <HelmetProvider>
        <ScrollToTop /> {/* 👈 Add this here */}

        <Routes>
          <Route path='/Header' element={<Header />} />
          <Route path='/Footer' element={<Footer />} />
          <Route path='/' element={<Home />} />
          <Route path='/about-us/' element={<About />} />
          <Route path='/adelaide-service' element={<AdelaideService />} />
          <Route path='/melbourne-service' element={<MelbourneService />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/service/house-cleaning/' element={<HomeCleaning />} />
          <Route path='/service/commercial-cleaning/' element={<CommercialCleaning />} />
          <Route path='/service/professional-gutter-cleaning/' element={<GutterCleaning />} />
          <Route path='/service/roof-cleaning/' element={<RoofCleaning />} />
          <Route path='/service/window-cleaning/' element={<WindowCleaning />} />
          <Route path='/service/pressure-cleaning/' element={<PressureCleaning />} />
          <Route path='/service/solar-panel-cleaning/' element={<SolarCleaning />} />
          <Route path='/service/ndis-cleaning/' element={<NDISCleaning />} />
          <Route path='/service/carpet-cleaning/' element={<CarpetSteamCleaning />} />
          <Route path='/service/oven-cleaning/' element={<OvenCleaning />} />
          <Route path='/faq-page' element={<Faq />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog-details/:id' element={<BlogDetail />} />
          <Route path='/free-quote' element={<GetQuote />} />


          <Route path='/service/once-off-house-cleaning/' element={<OnceOffHouseCleaning/>}/>
          <Route path='/service/regular-house-cleaning/' element={<RegularHouseCleaning/>}/>
          <Route path='/service/end-of-lease-cleaning/' element={<EndofLeaseCleaning/>}/>
          <Route path='/service/deep-cleaning/' element={<DeepHouseCleaning/>}/>
          <Route path='/service/office-cleaning/' element={<OfficeCleaning/>}/>
          <Route path='/service/aged-care/' element={<AgedCareCleaning/>}/>
          <Route path='/service/school-cleaning-education-cleaning/' element={<SchoolCleaning/>}/>
          <Route path='/service/medical-centre-cleaning/' element={<MedicalCentreCleaning/>}/>
          <Route path='/service/gutter-flushing/' element={<GutterFlushing/>}/>
          <Route path='/service/gutter-vacuum/' element={<GutterVacuum/>}/>
          <Route path='/service/roof-pressure-washing/' element={<RoofPressureWashing/>}/>
          <Route path='/service/roof-soft-wash/' element={<RoofSoftWash/>}/>

          <Route path='/googleaddress' element={<GoogleAddressInput/>}/>
          <Route path='/googleaddressSuggestion' element={<OpenCageAutocomplete/>}/>
        </Routes>
      </HelmetProvider>
    </BrowserRouter>

  );
}

export default App;
